<main>
  <section
    class="bg-cover bg-center bg-blend-multiply bg-black/50 min-h-[40vh] flex flex-col justify-center items-center text-white px-3 md:px-5 2xl:px-28 3xl:px-52"
    [ngStyle]="{
      'background-image': 'url(/assets/images/models/' + rawFormat + '.webp)'
    }"
  >
    <h1 class="text-white text-3xl lg:text-5xl font-extrabold text-center mb-3">
      Used Tesla {{ formattedModelName }} For Sale
    </h1>
    <p class="text-white font-semibold text-center text-lg lg:text-xl">
      Find the Best Deals on Pre-Owned Tesla {{ formattedModelName }} – Ready
      for Adventure!
    </p>
  </section>

  <section>
    <div class="px-3 md:px-5 2xl:px-28 3xl:px-52">
      <div *ngIf="!isLoading; else loading" class="container mx-auto py-10">
        <div
          class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 xl:gap-x-7 xl:gap-y-10"
        >
          <span *ngFor="let listing of listings">
            <out-listing-card [listing]="listing"></out-listing-card>
          </span>
        </div>

        <div *ngIf="listings.length === 0" class="text-center">
          <img
            src="/assets/images/no-data.png"
            class="mx-auto size-42"
            alt="No data image"
          />
          <h4 class="text-xl font-medium">
            There are currently no {{ formattedModelName }}'s available.
          </h4>
          <p>Please check back later.</p>
          <a
            routerLink="/used-tesla-for-sale"
            class="rounded-full bg-OUT-Blue hover:bg-OUT-Blue/90 transition-colors duration-300 px-6 py-2 text-white mt-3 inline-block cursor-pointer"
            >Go Back to Listings</a
          >
        </div>

        <div
          *ngIf="listings.length > 0"
          class="w-full flex justify-center items-center mt-10"
        >
          <out-paginator
            [pageResults]="pageResults"
            [skipResults]="skipResults"
            (pageChange)="onPaginationChange($event)"
          ></out-paginator>
        </div>
      </div>

      <ng-template #loading>
        <div
          class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-7 py-10"
        >
          <div *ngFor="let placeholderSkeleton of placeholderSkeletons">
            <out-listing-skeleton></out-listing-skeleton>
          </div>
        </div>
      </ng-template>
    </div>
  </section>
</main>
